import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// import axios from "axios";
import jQuery from "jquery";
import Auth from "./Auth";
import HttpService from "./services/HttpService";
import Swal from "sweetalert2";
window.jQuery = window.$ = jQuery;

// require("./assets/custom.css");

export { default as Footer } from "./components/Footer.vue";
export { default as InstagramArea } from "./components/instagram/InstagramArea.vue";
export { default as InstagramAreaElectronics } from "./components/instagram/InstagramAreaElectronics.vue";
export { default as InstagramSliderItem } from "./components/instagram/InstagramSliderItem.vue";
export { default as ProductBox1 } from "./components/products/ProductBox1.vue";

import "../node_modules/bootstrap/dist/css/bootstrap.css";

import "../node_modules/bootstrap-vue/dist/bootstrap-vue.css";

import "./assets/app.css";

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";

import InnerImageZoom from "vue-inner-image-zoom";
import "vue-inner-image-zoom/lib/vue-inner-image-zoom.css";

import VueSidebarMenu from "vue-sidebar-menu";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";

import Vuelidate from "vuelidate";
// import VueApexCharts from "vue-apexcharts";

require("vue2-animate/dist/vue2-animate.min.css");

import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

Vue.use(VueAwesomeSwiper);
Vue.component("inner-image-zoom", InnerImageZoom);
Vue.use(VueSidebarMenu);
Vue.use(Vuelidate);
// Vue.use(VueApexCharts);
// Vue.component("apexchart", VueApexCharts);
Vue.component("VueSlider", VueSlider);

import { BootstrapVue } from "bootstrap-vue";
import Alert from "./components/Alert.vue"; // adjust the path as needed

Vue.use(BootstrapVue, {});
Vue.component("Alert", Alert);
Vue.prototype.$swal = Swal;
Vue.prototype.$http = HttpService;
// Check if in egypt or not
// Vue.prototype.$country = this.$store.getters["country/countryCode"];
Vue.prototype.$auth = Auth;
Vue.mixin({
  computed: {
    $country() {
      return this.$store.getters["country/countryCode"];
    },
  },
});

Vue.directive("scroll-fade", {
  inserted(el, binding) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-in-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }, // Trigger when 10% of element is visible
    );
    observer.observe(el);
  },
});

store.dispatch("country/fetchCountryViaIpAddress").finally(() => {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
});
